import './ServiceCard.css';


function ServiceCard( {icon: Icon, title, description }) {
  return (
      <div className="service_card">
          <div>
            <Icon/>
          </div>
          <h3 className="">{title}</h3>
          <p className="">{description}</p>
      </div>
  );
}

export default ServiceCard